import PhaseOfPlay from "./PhaseOfPlay";

const PhaseOfPlayMap = {
  [PhaseOfPlay.ATTACKING]: "Attacking",
  [PhaseOfPlay.BUILD_UP]: "Build-up",
  [PhaseOfPlay.COUNTER_ATTACK]: "Counter attack",
};

export default PhaseOfPlayMap;
